import styled from "styled-components";
import { Box } from "styles/globalComponents";

export const Content = styled(Box)`
  width: 100%;

  .box-select-unit .field-holder {
    width: 100%;
    appearance: base-select;
  }
`;
